import React from 'react';

import { Col } from 'bs';
import Icon from 'components/Icon';
import { CenterBox } from './utils';

const RegistrationSent = () => (
    <CenterBox>
        <Col id='register-successful'>
            <h2 className='text-success'>
                <Icon name='paper-plane' className='mr-2' /> Registration Email Sent!
            </h2>
            <p>
                You should receive an email from us shortly. Click the 'Complete
                Registration' link in the email to sign in to your new account.
            </p>
        </Col>
    </CenterBox>
);

export default RegistrationSent;
